import {
    FaChartLine,
    FaCircleCheck,
    FaClock,
    FaShieldHeart,
    FaBrain, FaClipboardCheck, FaUserShield
} from "react-icons/fa6";

export const section1Data = [
    {
        value: "5+",
        label: "Years of Experience",
        icon: FaClock,
    },
    {
        value: "80%",
        label: "Success Rate",
        icon: FaChartLine,
    },
    {
        value: "20%",
        label: "Increased Revenue",
        icon: FaCircleCheck,
    },
    {
        value: "100%",
        label: "HIPAA Compliance",
        icon: FaShieldHeart,
    },
];


export const proPrograms = [
    {
        title: "Our Mission",
        description:
            "MITSI's mission is to improve patient care through innovative solutions. We provide cutting-edge technology to ensure accessibility and positive outcomes. Our goal is to empower healthcare providers with reliable tools.",
    },
    {
        title: "Our Vision",
        description:
            "We want to set new standards for patient care and drive industry-wide change. We want a future where patients and providers both benefit. They should have access to effective treatments that improve lives at all stages.",
    },
];

export const section2Data = [
    {
        icon: FaBrain,
        title: "Innovation-Driven",
        description:
            "Our services use cutting-edge tech. They keep you ahead in the fast-changing healthcare world.",
    },
    {
        icon: FaUserShield,
        title: "Patient-Centric Approach",
        description:
            "Our solutions, from neurofeedback therapies to lab setups, focus on patients. They also simplify processes for providers.",
    },
    {
        icon: FaClipboardCheck,
        title: "What We Handle",
        description:
            "From equipment and billing to compliance. You can focus on what you do best: providing exceptional care.",
    },
];